import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Custom Weight icon: Analog floor scale.
 * Matches the exact design from the reference image.
 */
const WeightSvgIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 64 64" {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      {/* Outer Scale Box */}
      <rect x="8" y="10" width="48" height="48" rx="4" ry="4" />
      
      {/* Inner Scale Box */}
      <rect x="12" y="14" width="40" height="40" rx="2" ry="2" />
      
      {/* Gauge Window */}
      <path d="M 22 34 L 16 22 Q 32 10 48 22 L 42 34 Z" />

      {/* Needle Base (Semi-circle) */}
      <path d="M 27 34 A 5 5 0 0 1 37 34" fill="currentColor" stroke="none" />
      
      {/* Needle Pointer */}
      <path d="M 30.5 34 L 32 18 L 33.5 34 Z" fill="currentColor" stroke="none" />

      {/* Tick Marks (from left to right) */}
      <line x1="20" y1="24" x2="22" y2="28" />
      <line x1="26" y1="18" x2="28" y2="22" />
      <line x1="38" y1="18" x2="36" y2="22" />
      <line x1="44" y1="24" x2="42" y2="28" />
    </g>
  </SvgIcon>
);

export default WeightSvgIcon;
